import { SpreadsheetSlice } from './types';
import { REDUX_KEY } from '../../constants';

const initialState: SpreadsheetSlice = {
  [REDUX_KEY.PRICING]: [],
  [REDUX_KEY.PEAK_LOADING]: [],
  [REDUX_KEY.STATION]: [],
  [REDUX_KEY.DAY_STRAT]: [],
  [REDUX_KEY.DURATION_LOADING]: [],
  [REDUX_KEY.WEEKLY_PRICING]: [],
  [REDUX_KEY.AD_MIRRORING]: []
};

export default initialState;
